export const ConfigValue = {
  PORT: process.env.PORT || 3000,
  PUBLIC_REST_API_ENDPOINT: process.env.REACT_APP_BASE_URL,
  PUBLIC_ENGAGEMENT_API_ENDPOINT: process.env.REACT_APP_ENGAGEMENT_API_URL,
  // Next.js app URL — used for the "back to Blitz" escape hatch on pages that
  // still live here (Commerce, T2A/Split fallback pages). See
  // docs/legacy-fallback-pages.md.
  NEXT_APP_URL: process.env.REACT_APP_NEXT_APP_URL,
  AUTH_TOKEN_KEY: "blitz-auth-token",
  AUTH_USER_INFO: "blitz-auth-user",
  AUTH_CREATOR_TOKEN_KEY: "blitz-creator-token",
  AUTH_CREATOR_USER_INFO: "blitz-creator-auth-user",
};